export const layingTypeColors = {
  SOIL_DISPLACEMENT: '#d5b60a',
  PULL: '#FF50F5',
  HORIZONTAL_DIRECTIONAL_DRILLING: '#7CFC00',
  PLOUGH: '#4597C9',
  LAYJET: '#943e94',
  MICRO_TRENCHING: '#ed6d6d',
  NOT_APPLICABLE: '#666666',
  OVERGROUND: '#00d2d3',
  CLAMPED: '#2244ee',
  HAND_DIGGING: '#8c564b',
};

export const externalDataDefaultColor = '#3272f7';

export const getLayingTypeColor = (layingType: keyof typeof layingTypeColors) => {
  return layingTypeColors[layingType] || externalDataDefaultColor;
};

const surfaceTypeColors = {
  UNPAVED_GRASS: '#7CFC00',
  SIMPLE_BRICK: '#BF40BF',
  HIGH_QUALITY_BRICK: '#570861',
  CONCRETE: '#FFA500',
  ASPHALT: '#006ee6',
  MISSING: '#f28c8a',
};

export const DepthColors = {
  NOT_APPLICABLE: '#666666',
  SIZE_0_CM: '#DAD3DB',
  SIZE_5_CM: '#CBBDCD',
  SIZE_10_CM: '#AC90AF',
  SIZE_15_CM: '#9C79A0',
  SIZE_20_CM: '#8C6392',
  SIZE_25_CM: '#7D4C83',
  SIZE_30_CM: '#6D3674',
  SIZE_35_CM: '#5E2066',
  SIZE_40_CM: '#570861',
  SIZE_45_CM: '#d455a3',
  SIZE_50_CM: '#f478fb',
  SIZE_55_CM: '#f000ff',
  SIZE_60_CM: '#bfcf29',
  SIZE_65_CM: '#a3ff00',
  SIZE_70_CM: '#00FF00',
  SIZE_75_CM: '#00FF1A',
  SIZE_80_CM: '#3272f7',
  SIZE_85_CM: '#65B3FB',
  SIZE_90_CM: '#FFA500',
  SIZE_95_CM: '#6653CB',
  SIZE_100_CM: '#2a03d6',
  SIZE_105_CM: '#5E4BE9',
  SIZE_110_CM: '#91E03C',
  SIZE_115_CM: '#84B132',
  SIZE_120_CM: '#77BC2E',
  SIZE_125_CM: '#73A42A',
  SIZE_130_CM: '#6F8C26',
  SIZE_135_CM: '#6B7422',
  SIZE_140_CM: '#675C1E',
  SIZE_145_CM: '#63441A',
  SIZE_150_CM: '#65A224',
  SIZE_155_CM: '#60A022',
  SIZE_160_CM: '#5B9E20',
  SIZE_165_CM: '#569C1E',
  SIZE_170_CM: '#519A1C',
  SIZE_175_CM: '#4C981A',
  SIZE_180_CM: '#479618',
  SIZE_185_CM: '#429416',
  SIZE_190_CM: '#3D9214',
  SIZE_195_CM: '#389012',
  SIZE_200_CM: '#338E10',
  SIZE_205_CM: '#2E8C0E',
  SIZE_210_CM: '#298A0C',
  SIZE_215_CM: '#24880A',
  SIZE_220_CM: '#1F8608',
  SIZE_225_CM: '#1A8406',
  SIZE_230_CM: '#158204',
  SIZE_235_CM: '#108002',
  SIZE_240_CM: '#0B7E00',
  SIZE_245_CM: '#0A7600',
  SIZE_250_CM: '#096E00',
  SIZE_255_CM: '#086600',
  SIZE_260_CM: '#075E00',
  SIZE_265_CM: '#065600',
  SIZE_270_CM: '#054E00',
  SIZE_275_CM: '#044600',
  SIZE_280_CM: '#033E00',
  SIZE_285_CM: '#023600',
  SIZE_290_CM: '#012E00',
  SIZE_295_CM: '#002600',
  SIZE_300_CM: '#001E00',
};

// TODO: Pick better colors
export const WidthColors = {
  NOT_APPLICABLE: '#666666',
  SIZE_0_CM: '#d455a3',
  SIZE_5_CM: '#cb5fa1',
  SIZE_10_CM: '#c3699e',
  SIZE_15_CM: '#bfcf29',
  SIZE_20_CM: '#9dc847',
  SIZE_25_CM: '#7cc165',
  SIZE_30_CM: '#3272f7',
  SIZE_35_CM: '#4b5ee9',
  SIZE_40_CM: '#645adb',
  SIZE_45_CM: '#642CB3',
  SIZE_50_CM: '#6A33B2',
  SIZE_55_CM: '#6130B4',
  SIZE_60_CM: '#5127B7',
  SIZE_65_CM: '#4724B8',
  SIZE_70_CM: '#3D21BA',
  SIZE_75_CM: '#3420BC',
  SIZE_80_CM: '#3F23BB',
  SIZE_85_CM: '#3722BD',
  SIZE_90_CM: '#2F21BE',
  SIZE_95_CM: '#271FC0',
  SIZE_100_CM: '#2D1EBF',
  SIZE_105_CM: '#271DC1',
  SIZE_110_CM: '#211CC3',
  SIZE_115_CM: '#1B1BC4',
  SIZE_120_CM: '#151AC6',
  SIZE_125_CM: '#1019C8',
  SIZE_130_CM: '#0A18C9',
  SIZE_135_CM: '#0517CB',
  SIZE_140_CM: '#0016CD',
  SIZE_145_CM: '#0015CE',
  SIZE_150_CM: '#1B19C3',
  SIZE_155_CM: '#1617C5',
  SIZE_160_CM: '#1116C7',
  SIZE_165_CM: '#0C14C9',
  SIZE_170_CM: '#0713CB',
  SIZE_175_CM: '#0211CD',
  SIZE_180_CM: '#0010CF',
  SIZE_185_CM: '#000FD1',
  SIZE_190_CM: '#000DD3',
  SIZE_195_CM: '#000BD6',
  SIZE_200_CM: '#0012C9',
};

export const roadContextColors = {
  NOT_APPLICABLE: '#666666',
  STREET_CROSSING: '#A1A1FF',
};

export const PointColors = {
  Default: '#000',
  Delete: '#ff0000',
  Endpoint: '#fff',
  HasMarker: '#ff6a00',
  Hover: '#fff',
  Selected: '#00ff00',
  ...layingTypeColors,
  ...surfaceTypeColors,
  ...roadContextColors,
};

export const SegmentColors = {
  Default: '#000',
  WithElement: '#000',
  ScanMode: '#f84700',
  Hover: '#009600',
  Selected: '#00ff00',
  TrenchMode: '#000',
  MissingElement: '#ff0000',
  ...layingTypeColors,
  ...surfaceTypeColors,
  ...roadContextColors,
};

export const PointOpacity = {
  Hover: 0.75,
  Default: 0.5,
  Endpoint: 0.25,
};

export const TrenchOpacity = {
  Hover: 1,
  Light: 0.25,
  Selected: 0.5,
  Default: 1,
};
